<template>
  <span :class="ns.e('total')" :disabled="disabled">
    {{
      t('z.pagination.total', {
        total,
      })
    }}
  </span>
</template>

<script lang="ts" setup>
import { useLocale, useNamespace } from '@zoryn/hooks'
import { usePagination } from '../usePagination'
import { paginationTotalProps } from './total'

const { t } = useLocale()
const ns = useNamespace('pagination')
const { disabled } = usePagination()

defineOptions({
  name: 'ZPaginationTotal',
})

defineProps(paginationTotalProps)
</script>
